import { mapMutations, mapActions } from 'vuex'
import i18n from '@/plugins/i18n'

export const breakpoints = {
  computed: {
    $_breakpoints_mobile() {
      return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm)
    },
    $_breakpoints_desktop() {
      return (this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl)
    },
  },
}

export const janusRegistration = {
  computed: {
    $_janusRegistration_registerEnabled: {
      get() {
        return this.$store.getters['settings/isRegisterEnabled']
      },
      async set(value) {
        await this.$store.dispatch('settings/setRegisterEnabled', value)
      },
    },
  },
}

export const contacts = {
  computed: {
    contacts() {
      return this.$store.getters['contacts/items']
    },
  },
  methods: {
    ...mapMutations('contacts', ['updateLoading', 'updateFetchError']),
    ...mapActions('snackbar', {
      snackbarShow: 'show',
    }),
    ...mapActions('contacts', {
      fetchContactsItems: 'fetchItems',
    }),
    $_contacts_getOneContact(number) {
      const contact = this.contacts.filter((item) => item.number === number || item.number_ext === number)
      if (contact.length > 0) {
        return contact[0]
      }
      return null
    },
    async $_contacts_getContacts() {
      this.updateLoading(true)
      this.updateFetchError(false)
      try {
        await this.fetchContactsItems({})
      } catch (err) {
        this.updateFetchError(true)
        if (err.response.status !== 401) {
          // 401 handled by error interceptor
          await this.snackbarShow({ message: this.$t(`errors["${err.code}"]`) })
        }
      } finally {
        this.updateLoading(false)
      }
    },
  },
}

export const calls = {
  methods: {
    $_calls_getInterlocutor(item) {
      if (item.direction === 'incoming' || item.direction === 'forwarded') {
        return item.caller
      } else if (item.direction === 'outgoing') {
        return item.callee
      } else {
        return i18n.t('call.Unknown')
      }
    },
    $_calls_getFilename(item) {
      return `${item.connect_time} - ${this.$_calls_getInterlocutor(item)}`
    },
  },
}

export const errors = {
  methods: {
    $_errors_parse(err) {
      let code = ''
      const error = err.response?.data
      if (error) {
        if (error.code === 'parameters_validate_issue') {
          const details = error.refining || error.details || []
          details.forEach((item) => {
            code += `${this.$t(`errors.${error.code}.${item.path}.${item.reason}`)}\n`
          })
        } else {
          code = this.$t(`errors.${error.code}`)
        }
      }
      return code
    },
  },
}
